export const Post = {
  onLoad: function() {
    if ($('body.single').length) {
      this.checkYouTubeIframe();
    }
  },
  checkYouTubeIframe: function() {
    console.log('checkYouTubeIframe');
    if ($('#post-content iframe').length) {
      $('#post-content iframe').each(function() {
        if ($(this).attr('src').indexOf('youtube.com') !== -1 || $(this).attr('src').indexOf('vimeo.com') !== -1 || $(this).attr('src').indexOf('wistia.net') !== -1) {
          $(this).wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
        }
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/Post.js